import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-siteuser',
  templateUrl: './siteuser.component.html',
  styleUrls: ['./siteuser.component.css']
})
export class SiteuserComponent implements OnInit {
  data: User[];
  UserDataAny: any;

  constructor(private router: Router, private userService: UserService) { }

  ngOnInit() {
    this.getUsersData();
  }

  getUsersData() {
    this.userService.getUsersData().subscribe(
      (data) => {
        this.UserDataAny = data;
        this.data = this.UserDataAny;
        //console.log("user data"+this.data);
      }
    )
  }

  editSiteUser(id) {
    //alert(id);
    this.router.navigate(['/siteuseredit/' + id + '']);
  }

  removeSiteUser(id) {
    this.userService.RemoveSiteUser(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getUsersData();
        }
      }
    )
  }

  deleteSiteUser(id) {
    this.userService.deleteSiteUser(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getUsersData();
        }
      }
    )
  }

  filterProductList(keyword)
  {
    this.userService.filterUsers(keyword).subscribe(
      (data : any) => {
        this.data = data;
        console.log(data);
      }
    );
  }


}
